/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfWatchlistV1Fincen314EntryState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_WATCHLIST_V1_FINCEN314_ENTRY_STATE_ENTITY_NAME = 'ixf.watchlist.v1.Fincen_314Entry';
export const ixfWatchlistV1Fincen314EntryStateEntity = new schema.Entity<IxfWatchlistV1Fincen314EntryState>(IXF_WATCHLIST_V1_FINCEN314_ENTRY_STATE_ENTITY_NAME, {}, { idAttribute: 'fincen314EntryId' });

